import script from "./TheFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./TheFooter.vue?vue&type=script&setup=true&lang=js"

import "./TheFooter.vue?vue&type=style&index=0&id=2cb17254&scoped=true&lang=scss"

import exportComponent from "/Users/kadir.aslan/Projects/Repositories/Personal/kadiraslan-de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cb17254"]])

export default __exports__